import React from 'react'
import PropTypes from 'prop-types'
import { InputsFormGroup } from '../InputsFormGroup/InputsFormGroup'
import { Select } from '../Select/Select'
import { RadioButtons } from '../RadioButtons/RadioButtons'
import { MultipleInnerInputs } from '../MultipleInnerInputs/MultipleInnerInputs'
import { Checkbox } from '../Checkbox/Checkbox'

const Field = ({type, getValue, label, elements, savedData, name, required, visibleValues, multipleInput, minDateForCalendar, maxDateForCalendar, expandInputArea}) => {
  if (type === 'textInput') {
    return <InputsFormGroup
      expandInputArea={expandInputArea}
      minDateForCalendar={minDateForCalendar}
      maxDateForCalendar={maxDateForCalendar}
      multipleInput={multipleInput}
      savedData={savedData}
      label={label}
      getFieldValue={getValue}
      fields={elements} />
  } else if (type === 'radioButtons') {
    return <RadioButtons
      expandInputArea={expandInputArea}
      savedData={savedData}
      label={label}
      getFieldValue={getValue}
      name={name}
      required={required}
      innerField={elements.innerField}
      inputs={elements.inputs} />
  } else if (type === 'select') {
    return <Select
      expandInputArea={expandInputArea}
      visibleValues={visibleValues}
      savedData={savedData}
      required={required}
      label={label}
      getFieldValue={getValue}
      name={name}
      options={elements.options} />
  } else if (type === 'multipleInnerInputs') {
    return <MultipleInnerInputs
      savedData={savedData}
      label={label}
      name={name}
      getFieldValue={getValue}
      fields={elements} />
  } else if (type === 'multipleChoices') {
    return <Checkbox
      savedData={savedData}
      required={required}
      label={label}
      getFieldValue={getValue}
      name={name}
      options={elements.options} />
  } else {
    window.myLogger.error(`type: ${type.toString()}, elements: ${JSON.stringify(elements)}, name: ${name}, visibleValues: ${visibleValues}`)
    return null
  }
}

Field.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  multipleInput: PropTypes.bool,
  elements: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  getValue: PropTypes.func.isRequired,
  name: PropTypes.string,
  required: PropTypes.bool,
  expandInputArea: PropTypes.bool,
  visibleValues: PropTypes.array,
  savedData: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array, PropTypes.number]),
  minDateForCalendar: PropTypes.string,
  maxDateForCalendar: PropTypes.string
}

export { Field }



// WEBPACK FOOTER //
// ./src/components/common/Field/Field.js